import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  LinearProgress,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { useSnackbar } from "notistack";
import React, { useCallback, useState } from "react";
import AuthService from "../../../AuthService";

const ConfigQr = ({ open, handleToggle }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [configuracoes, setConfiguracoes] = useState({ size: 500, margin: 1 });
  const [baixando, setBaixando] = useState(false);

  const validaTamanho = () => {
    const size = configuracoes.size;
    return !size || size > 3000 || size < 57;
  };

  const validaMargin = () => {
    const margin = configuracoes.margin;
    return margin < 0 || margin > 5;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setConfiguracoes((prev) => ({ ...prev, [name]: value }));
  };

  const donwloadQRCodes = useCallback(() => {
    const size = parseInt(configuracoes.size);
    const margin = parseInt(configuracoes.margin);
    setBaixando(true);

    const service = new AuthService();
    service
      .download(`/identificador/donwloadQRCodesPerso/${size}/${margin}`)
      .then((retorno) => {
        const url = window.URL.createObjectURL(retorno);
        const a = document.createElement("a");
        a.href = url;
        a.download = "qrcode-mesas.zip";
        document.body.appendChild(a);
        a.click();
        a.remove();
        setBaixando(false);
      })
      .catch((err) => {
        setBaixando(false);
        if (err.response === undefined) {
          enqueueSnackbar("Falha ao tentar gerar e baixar QRcode's", {
            variant: "error",
          });
        } else {
          err.response.json().then((elem) => {
            enqueueSnackbar(
              "Falha ao gerar e baixar QRcode's" + elem.errorMessage,
              { variant: "error" }
            );
          });
        }
      });
  }, [configuracoes, enqueueSnackbar]);

  return (
    <Dialog style={{ height: "60vh" }} open={open} onClose={handleToggle}>
      <DialogContent>
        <Grid
          sx={{
            fontSize: "200%",
            textAlign: "center",
            fontFamily: "Bebas Neue",
            textTransform: "uppercase",
          }}
        >
          <strong>Configurações de QRcode</strong>
        </Grid>

        <Grid>
          <Divider sx={{ marginTop: "18px" }} />
          {baixando && <LinearProgress color="primary" />}
        </Grid>

        <Grid container spacing={2} sx={{ marginTop: "4vh" }}>
          <Grid size={6}>
            <TextField
              error={validaTamanho()}
              fullWidth
              variant="outlined"
              label="Tamanho"
              name="size"
              type="number"
              value={configuracoes.size || ""}
              required
              helperText={
                validaTamanho()
                  ? "MÍNIMO de tamanho:57px / MÁXIMO de tamanho: 3000px"
                  : "Tamanho em pixels (1Cm = 28px)"
              }
              onChange={handleChange}
            />
          </Grid>

          <Grid size={6}>
            <TextField
              error={validaMargin()}
              fullWidth
              variant="outlined"
              label="Margem"
              name="margin"
              type="number"
              value={configuracoes.margin || ""}
              required
              helperText={
                validaMargin()
                  ? "Preencha com um valor de 0 a 5"
                  : "MÍNIMO: 0 / MÁXIMO: 5"
              }
              onChange={handleChange}
              style={{ marginLeft: "15px" }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="secondary"
          style={{
            fontFamily: "Bebas Neue",
            textTransform: "uppercase",
            margin: "0 30px 2vh 0",
          }}
          size="large"
          onClick={handleToggle}
          disabled={baixando}
        >
          Cancelar
        </Button>

        <Button
          variant="contained"
          color="primary"
          style={{
            fontFamily: "Bebas Neue",
            textTransform: "uppercase",
            margin: "0 30px 2vh 0",
          }}
          size="large"
          onClick={donwloadQRCodes}
          disabled={baixando}
        >
          {baixando ? "Aguarde..." : "Baixar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfigQr;
